// extracted by mini-css-extract-plugin
export default {"svg":"CloseWindowButton_svg__aXrve"};